import * as Sentry from "@sentry/core";

const LOW_SAMPLED_DB_QUERY_SPAN_RATE = 0.1;

const LOW_SAMPLED_DB_QUERY_SPAN_NAMES = [
  "SELECT * from get_auth_user(p_uid => $1);",
  "SELECT * from get_tables(restaurant_id_input => $1);",
  "SELECT * from get_orders(restaurant_id_input => $1, order_statuses_input => $2);",
  `select "id", "shop_id", "user_id", "model_id", "model_type", "name", "payload", "tx_id", "created_at" from "shop_events" where ("shop_events"."shop_id" = $1 and "shop_events"."id" > $2) order by "shop_events"."id" asc limit $3`,
];

const normalizeDbQuerySpanName = (queryText: string) =>
  queryText.replace(/\s+/g, " ").trim().toLowerCase();

const lowSampledDbQuerySpanNames = new Set(
  LOW_SAMPLED_DB_QUERY_SPAN_NAMES.map(normalizeDbQuerySpanName),
);

export const startInactiveSpan = (
  options: Parameters<typeof Sentry.startInactiveSpan>[0],
) => {
  return Sentry.startInactiveSpan(options);
};

export const getDbQuerySpanSampleRate = (queryText: string) => {
  return lowSampledDbQuerySpanNames.has(normalizeDbQuerySpanName(queryText))
    ? LOW_SAMPLED_DB_QUERY_SPAN_RATE
    : 1;
};

export const shouldSampleDbQuerySpan = (
  queryText: string,
  random: () => number = Math.random,
) => {
  const sampleRate = getDbQuerySpanSampleRate(queryText);

  if (sampleRate >= 1) {
    return true;
  }

  if (sampleRate <= 0) {
    return false;
  }

  return random() < sampleRate;
};

export const startDbQuerySpan = (queryText: string) => {
  if (!shouldSampleDbQuerySpan(queryText)) {
    return undefined;
  }

  return startInactiveSpan({
    op: "db.query",
    name: queryText,
  });
};
